import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { VehicleModel } from './../../vehicle/models/vehicle.model';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel, Permission } from '../../shared/config';
import { PersonModel } from '../../person/models/person.model';
import { VehicleService } from '../../vehicle/models/vehicle.service';
import { fail } from 'assert';


@Component({
  selector: 'wego-booking-vehicle-popup',
  template: require('../views/booking-vehicle-popup.component.html'),
  providers: [VehicleService]
})

export class BookingVehiclePopupComponent implements OnInit, OnChanges {
  SelectedNames: string[] = [];
  SelectedList: string[] = [];
  svgHashId: string;
  DataListModel: DataListModel;
  vehicleList: VehicleModel[];
  message: string;
  apiErrorMsg: string;
  isLoading: boolean;
  LblIcon: string = "fa fa-plus-square";
  isParentCheck: boolean = false;

  @Output('OnSuccessSelect') onSuccessSelect = new EventEmitter();
  @ViewChild('vehicleModal') public vehicleModal: any;

  constructor(private vehicleService: VehicleService
    , private authService: AuthService
    , private router: Router
    , private translate: TranslateService) { }

  ngOnInit() {
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ["licenceTag", 'ownerName', 'brand', 'type', 'vehicleClass', 'color'];
  }

  ngOnChanges(change: any) {
    console.log(change);
  }

  public show(svgHashId: string, SelectedList: string[], SelectedNameList: string[]): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = "";
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = "";
    this.DataListModel.infoMessage = "";
    this.svgHashId = svgHashId;
    this.SelectedList = SelectedList;
    this.SelectedNames = SelectedNameList;
    this.GetVehicleList();
    this.vehicleModal.show();
  }

  public hide(): void {
    this.vehicleModal.hide();
  }

  private GetVehicleList() {
    this.isLoading = true;
    this.vehicleService.GetVehicleList(this.DataListModel, null, this.svgHashId, null, false,false,false,false,Permission.PR_BOOKINGS_OVERVIEW)
      .subscribe(
      res => {
        this.vehicleList = res.data;
        this.vehicleList.forEach(x => x.isChecked =
          (this.SelectedList.indexOf(x.vehicleMasterHashId) > -1)
        );        

        this.isParentCheck = this.vehicleList.every(x => x.isChecked);

        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  private select(vehicle: VehicleModel): void {
    this.isLoading = true;
    this.onSuccessSelect.emit({ VehicleMasterHashID: vehicle.vehicleMasterHashId, LicenceTage: vehicle.licenceTag });
    this.isLoading = false;
    this.hide();
  }

  private selectMultiple(): void {
    this.isLoading = true;

    this.onSuccessSelect.emit({ VehicleMasterHashID: this.SelectedList, LicenceTage: this.SelectedNames });
    this.isLoading = false;
    this.hide();
  }

  private ItemCheckChanged(VehicleMasterHashId: string, LicenceTag: string, isChecked: any) {
    if (isChecked) {
      if (this.SelectedList.indexOf(VehicleMasterHashId) == -1) {
        this.SelectedList.push(VehicleMasterHashId);
      }
      if (this.SelectedNames.indexOf(LicenceTag) == -1) {
        this.SelectedNames.push(LicenceTag);
      }
      this.isParentCheck = this.vehicleList.filter(x => x.vehicleMasterHashId != VehicleMasterHashId).every(x => x.isChecked);
    } else {
      this.SelectedList = this.SelectedList.filter(x => x != VehicleMasterHashId);
      this.SelectedNames = this.SelectedNames.filter(x => x != LicenceTag);
      this.isParentCheck= false;
    }

  }

  public OnParentCheck(isChecked: boolean) {
    this.vehicleList.forEach(x => {
      x.isChecked = isChecked;
      if (isChecked) {
        if (this.SelectedList.indexOf(x.vehicleMasterHashId) == -1) {
          this.SelectedList.push(x.vehicleMasterHashId);
        }
        if (this.SelectedNames.indexOf(x.licenceTag) == -1) {
          this.SelectedNames.push(x.licenceTag);
        }
      } else {
        this.SelectedList = this.SelectedList.filter(y => y != x.vehicleMasterHashId);
        this.SelectedNames = this.SelectedNames.filter(y => y != x.licenceTag);
      }
    }
    );
  }

  private OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetVehicleList();
  }

  private OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetVehicleList();
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetVehicleList();
  };
  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetVehicleList();
  }
  private OnSuccessSelect() {
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/components/booking-vehicle-popup.component.ts